module.exports = __webpack_public_path__ + "static/media/scenarios.f915320c.gif";